import { useEffect } from "react";

/**
 * Injects (and cleans up) a JSON-LD <script> tag in document.head.
 * `key` MUST be unique per page; `data` is any serialisable schema.org object
 * (or null/undefined to skip injection).
 */
export const useStructuredData = (key, data) => {
  useEffect(() => {
    if (!data) return undefined;
    const id = `ld-${key}`;
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("script");
      el.setAttribute("type", "application/ld+json");
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
    };
  }, [key, data]);
};
